import http from "@/services/http";

/**
 * Lista as avaliações de hidratação de um paciente
 * (tabela patient_hydration_assessments), mais recente primeiro.
 *
 * @param {number|string} patientId
 * @returns {Promise<object[]>}
 */
export async function getHydrationByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-hydration-assessments/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Cria uma avaliação de hidratação (salvia-759).
 * @param {number|string} patientId
 * @param {object} payload { liters_per_day?, assessed_at?, notes? }
 */
export function createHydration(patientId, payload) {
  return http.post("/api/patient-hydration-assessments/create", {
    patient_id: patientId,
    ...payload,
  });
}

/**
 * Atualiza uma avaliação de hidratação existente.
 */
export function updateHydration(id, payload) {
  return http.put(`/api/patient-hydration-assessments/update/${id}`, payload);
}

/**
 * Remove uma avaliação de hidratação (soft delete).
 */
export function deleteHydration(id) {
  return http.delete(`/api/patient-hydration-assessments/delete/${id}`);
}
